import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var t = Object.defineProperty,
    r = Object.defineProperties,
    n = Object.getOwnPropertyDescriptors,
    e = Object.getOwnPropertySymbols,
    o = Object.prototype.hasOwnProperty,
    c = Object.prototype.propertyIsEnumerable,
    i = function i(r, n, e) {
  return n in r ? t(r, n, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: e
  }) : r[n] = e;
},
    a = function a(t, r) {
  for (var n in r || (r = {})) {
    o.call(r, n) && i(t, n, r[n]);
  }

  if (e) {
    var _iterator = _createForOfIteratorHelper(e(r)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var n = _step.value;
        c.call(r, n) && i(t, n, r[n]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return t;
},
    s = function s(t, e) {
  return r(t, n(e));
};

import { createContext as u, useContext as l, useEffect as f, useState as d, useCallback as p, useRef as h, useReducer as g } from "react";
var y = u(void 0),
    b = y.Provider,
    v = y.Consumer;

function w() {
  var t = l(y);
  if (void 0 === t) throw Error("No client has been specified using Provider.");
  return t;
}

function m(t) {
  var r = w();
  f(function () {
    var _r$auth$onAuthStateCh = r.auth.onAuthStateChange(t),
        n = _r$auth$onAuthStateCh.data;

    return function () {
      null == n || n.unsubscribe();
    };
  }, []);
}

y.displayName = "SupabaseContext";
var E = {
  error: void 0,
  fetching: !1
};

function O() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var r = w(),
      _d = d(E),
      _d2 = _slicedToArray(_d, 2),
      n = _d2[0],
      e = _d2[1];

  return [n, p( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(n, o) {
      var _yield$r$auth$api$res, c, i;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e(s(a({}, E), {
                fetching: !0
              }));
              _context.next = 3;
              return r.auth.api.resetPasswordForEmail(n, null != o ? o : t.options);

            case 3:
              _yield$r$auth$api$res = _context.sent;
              c = _yield$r$auth$api$res.error;
              i = {
                error: c
              };
              return _context.abrupt("return", (e(s(a({}, i), {
                fetching: !1
              })), i));

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), [r, t])];
}

var P = {
  error: void 0,
  fetching: !1,
  session: void 0,
  user: void 0
};

function C() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var r = w(),
      _d3 = d(P),
      _d4 = _slicedToArray(_d3, 2),
      n = _d4[0],
      e = _d4[1];

  return [n, p( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(n, o) {
      var _yield$r$auth$signIn, c, i, u, l;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              e(s(a({}, P), {
                fetching: !0
              }));
              _context2.next = 3;
              return r.auth.signIn(a({
                provider: t.provider
              }, n), null != o ? o : t.options);

            case 3:
              _yield$r$auth$signIn = _context2.sent;
              c = _yield$r$auth$signIn.error;
              i = _yield$r$auth$signIn.session;
              u = _yield$r$auth$signIn.user;
              l = {
                error: c,
                session: i,
                user: u
              };
              return _context2.abrupt("return", (e(s(a({}, l), {
                fetching: !1
              })), l));

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }(), [r, t])];
}

var I = {
  error: void 0,
  fetching: !1
};

function S() {
  var t = w(),
      _d5 = d(I),
      _d6 = _slicedToArray(_d5, 2),
      r = _d6[0],
      n = _d6[1];

  return [r, p( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var _yield$t$auth$signOut, r, e;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            n(s(a({}, I), {
              fetching: !0
            }));
            _context3.next = 3;
            return t.auth.signOut();

          case 3:
            _yield$t$auth$signOut = _context3.sent;
            r = _yield$t$auth$signOut.error;
            e = {
              error: r
            };
            return _context3.abrupt("return", (n(s(a({}, e), {
              fetching: !1
            })), e));

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })), [t])];
}

function T() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var r = w(),
      _d7 = d(P),
      _d8 = _slicedToArray(_d7, 2),
      n = _d8[0],
      e = _d8[1];

  return [n, p( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(n, o) {
      var _yield$r$auth$signUp, c, i, u, l;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              e(s(a({}, P), {
                fetching: !0
              }));
              _context4.next = 3;
              return r.auth.signUp(n, null != o ? o : t.options);

            case 3:
              _yield$r$auth$signUp = _context4.sent;
              c = _yield$r$auth$signUp.error;
              i = _yield$r$auth$signUp.session;
              u = _yield$r$auth$signUp.user;
              l = {
                error: c,
                session: i,
                user: u
              };
              return _context4.abrupt("return", (e(s(a({}, l), {
                fetching: !1
              })), l));

            case 9:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x5, _x6) {
      return _ref4.apply(this, arguments);
    };
  }(), [r, t])];
}

var j = {
  count: void 0,
  data: void 0,
  error: void 0,
  fetching: !1
};

function N(t) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    options: {}
  };

  var n = w(),
      e = h(!1),
      _d9 = d(j),
      _d10 = _slicedToArray(_d9, 2),
      o = _d10[0],
      c = _d10[1],
      i = p( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(o, i) {
      var u, l, _yield$u, f, d, p, h;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              u = null != o ? o : r.filter;

              if (!(void 0 === u)) {
                _context5.next = 3;
                break;
              }

              throw Error("delete() should always be combined with `filter`");

            case 3:
              c(s(a({}, j), {
                fetching: !0
              }));
              l = n.from(t).delete(null != i ? i : r.options);
              _context5.next = 7;
              return u(l);

            case 7:
              _yield$u = _context5.sent;
              f = _yield$u.count;
              d = _yield$u.data;
              p = _yield$u.error;
              h = {
                count: f,
                data: d,
                error: p
              };
              return _context5.abrupt("return", (e.current && c(s(a({}, h), {
                fetching: !1
              })), h));

            case 13:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x7, _x8) {
      return _ref5.apply(this, arguments);
    };
  }(), [n]);

  return f(function () {
    return e.current = !0, function () {
      e.current = !1;
    };
  }, []), [o, i];
}

function U(t) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return p(t, r);
}

function x(t) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    options: {}
  };

  var n = w(),
      e = h(!1),
      _d11 = d(j),
      _d12 = _slicedToArray(_d11, 2),
      o = _d12[0],
      c = _d12[1],
      i = p( /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(o, i) {
      var _yield$n$from$insert, u, l, f, d;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              c(s(a({}, j), {
                fetching: !0
              }));
              _context6.next = 3;
              return n.from(t).insert(o, null != i ? i : r.options);

            case 3:
              _yield$n$from$insert = _context6.sent;
              u = _yield$n$from$insert.count;
              l = _yield$n$from$insert.data;
              f = _yield$n$from$insert.error;
              d = {
                count: u,
                data: l,
                error: f
              };
              return _context6.abrupt("return", (e.current && c(s(a({}, d), {
                fetching: !1
              })), d));

            case 9:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x9, _x10) {
      return _ref6.apply(this, arguments);
    };
  }(), [n]);

  return f(function () {
    return e.current = !0, function () {
      e.current = !1;
    };
  }, []), [o, i];
}

function D(t) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    columns: "*",
    options: {}
  };

  var n = w(),
      e = h(!1),
      _d13 = d(s(a({}, j), {
    stale: !1
  })),
      _d14 = _slicedToArray(_d13, 2),
      o = _d14[0],
      c = _d14[1],
      i = p( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    var o, _yield, i, u, l, f;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (!r.pause) {
              _context7.next = 2;
              break;
            }

            return _context7.abrupt("return", null);

          case 2:
            c(function (t) {
              return s(a({}, j), {
                data: t.data,
                stale: !0,
                fetching: !0
              });
            });
            o = n.from(t).select(r.columns, r.options);
            _context7.next = 6;
            return r.filter ? r.filter(o) : o;

          case 6:
            _yield = _context7.sent;
            i = _yield.count;
            u = _yield.data;
            l = _yield.error;
            f = {
              count: i,
              data: u,
              error: l
            };
            return _context7.abrupt("return", (e.current && c(s(a({}, f), {
              stale: !1,
              fetching: !1
            })), f));

          case 12:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  })), [n, r, t]);

  return f(function () {
    return e.current = !0, i(), function () {
      e.current = !1;
    };
  }, [null == r ? void 0 : r.filter]), [o, i];
}

function F(t) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    options: {}
  };

  var n = w(),
      e = h(!1),
      _d15 = d(j),
      _d16 = _slicedToArray(_d15, 2),
      o = _d16[0],
      c = _d16[1],
      i = p( /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(o, i, u) {
      var l, f, _yield$l, d, p, h, g;

      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              l = null != i ? i : r.filter;

              if (!(void 0 === l)) {
                _context8.next = 3;
                break;
              }

              throw Error("update() should always be combined with `filter`");

            case 3:
              c(s(a({}, j), {
                fetching: !0
              }));
              f = n.from(t).update(o, null != u ? u : r.options);
              _context8.next = 7;
              return l(f);

            case 7:
              _yield$l = _context8.sent;
              d = _yield$l.count;
              p = _yield$l.data;
              h = _yield$l.error;
              g = {
                count: d,
                data: p,
                error: h
              };
              return _context8.abrupt("return", (e.current && c(s(a({}, g), {
                fetching: !1
              })), g));

            case 13:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function (_x11, _x12, _x13) {
      return _ref8.apply(this, arguments);
    };
  }(), [n]);

  return f(function () {
    return e.current = !0, function () {
      e.current = !1;
    };
  }, []), [o, i];
}

function R(t) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    options: {}
  };

  var n = w(),
      e = h(!1),
      _d17 = d(j),
      _d18 = _slicedToArray(_d17, 2),
      o = _d18[0],
      c = _d18[1],
      i = p( /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(o, i, u) {
      var l, f, _yield2, d, p, h, g;

      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              l = null != u ? u : r.filter;
              c(s(a({}, j), {
                fetching: !0
              }));
              f = n.from(t).upsert(o, null != i ? i : r.options);
              _context9.next = 5;
              return l ? l(f) : f;

            case 5:
              _yield2 = _context9.sent;
              d = _yield2.count;
              p = _yield2.data;
              h = _yield2.error;
              g = {
                count: d,
                data: p,
                error: h
              };
              return _context9.abrupt("return", (e.current && c(s(a({}, g), {
                fetching: !1
              })), g));

            case 11:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function (_x14, _x15, _x16) {
      return _ref9.apply(this, arguments);
    };
  }(), [n]);

  return f(function () {
    return e.current = !0, function () {
      e.current = !1;
    };
  }, []), [o, i];
}

function A(t) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    event: "*",
    table: "*"
  };
  var n = w();
  f(function () {
    var e, o;
    var c = n.from(null != (e = r.table) ? e : "*").on(null != (o = r.event) ? o : "*", t).subscribe();
    return function () {
      c.unsubscribe();
    };
  }, []);
}

function B(t, r) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (t, r) {
    return t.id === r.id;
  };
  if ("*" === t) throw Error("Must specify table or row. Cannot listen for all database changes.");

  var _D = D(t, null == r ? void 0 : r.select),
      _D2 = _slicedToArray(_D, 2),
      e = _D2[0],
      o = _D2[1],
      _g = g(H(n), e),
      _g2 = _slicedToArray(_g, 2),
      c = _g2[0],
      i = _g2[1];

  return A(function (t) {
    return i({
      type: "SUBSCRIPTION",
      payload: t
    });
  }, {
    table: t
  }), f(function () {
    i({
      type: "FETCH",
      payload: e
    });
  }, [e]), [c, o];
}

var H = function H(t) {
  return function (r, n) {
    var e;
    var o = r.data;

    switch (n.type) {
      case "FETCH":
        return a(s(a({}, r), {
          old: o
        }), n.payload);

      case "SUBSCRIPTION":
        switch (n.payload.eventType) {
          case "DELETE":
            return s(a({}, r), {
              data: null == (e = r.data) ? void 0 : e.filter(function (r) {
                return !t(r, n.payload.old);
              }),
              fetching: !1,
              old: o
            });

          case "INSERT":
            return s(a({}, r), {
              data: [].concat(_toConsumableArray(null != o ? o : []), [n.payload.new]),
              fetching: !1,
              old: o
            });

          case "UPDATE":
            {
              var _e = null != o ? o : [],
                  _c = _e.findIndex(function (r) {
                return t(r, n.payload.new);
              });

              return s(a({}, r), {
                data: [].concat(_toConsumableArray(_e.slice(0, _c)), [n.payload.new], _toConsumableArray(_e.slice(_c + 1))),
                fetching: !1,
                old: o
              });
            }
        }

    }
  };
};

export { v as Consumer, y as Context, b as Provider, m as useAuthStateChange, w as useClient, N as useDelete, U as useFilter, x as useInsert, B as useRealtime, O as useResetPassword, D as useSelect, C as useSignIn, S as useSignOut, T as useSignUp, A as useSubscription, F as useUpdate, R as useUpsert };